import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { AuthProvider } from './context/AuthContext.js';
import { TenantProvider } from './context/TenantContext.js';
import { ToastProvider } from './components/Toast.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { Layout } from './components/Layout.js';

// pages
import { LoginPage } from './pages/Login.js';
import { TotpSetupPage } from './pages/TotpSetup.js';
import { TotpVerifyPage } from './pages/TotpVerify.js';
import { PendingApprovalPage } from './pages/PendingApproval.js';
import { OnboardingPage } from './pages/Onboarding.js';
import { OverviewPage } from './pages/Overview.js';
import { UsersPage } from './pages/Users.js';
import { PlansPage } from './pages/Plans.js';
import { PaymentsPage } from './pages/Payments.js';
import { EmbedsPage } from './pages/Embeds.js';
import { BotPersonalizerPage } from './pages/BotPersonalizer.js';
import { AffiliatesPage } from './pages/Affiliates.js';
import { SettingsPage } from './pages/Settings.js';
import { AdminTenantsPage } from './pages/admin/AdminTenants.js';
import { AdminUsersPage } from './pages/admin/AdminUsers.js';
import { AdminWhitelistPage } from './pages/admin/AdminWhitelist.js';
import { AdminPaymentsPage } from './pages/admin/AdminPayments.js';
import { AdminRolesPage } from './pages/admin/AdminRoles.js';
import { GuidePage } from './pages/Guide.js';

export function App() {
  return (
    <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <ToastProvider>
          <Routes>
            {/* public / auth routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/totp-setup" element={<TotpSetupPage />} />
            <Route path="/totp-verify" element={<TotpVerifyPage />} />

            {/* fullscreen pages — auth-protected but no server/whitelist check */}
            <Route
              path="/pending-approval"
              element={
                <ProtectedRoute skipServerCheck>
                  <PendingApprovalPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute skipServerCheck>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />

            {/* protected dashboard routes */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<OverviewPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/plans" element={<PlansPage />} />
              <Route path="/payments" element={<PaymentsPage />} />
              <Route path="/embeds" element={<EmbedsPage />} />
              <Route path="/bot" element={<BotPersonalizerPage />} />
              <Route path="/affiliates" element={<AffiliatesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/guide" element={<GuidePage />} />

              {/* admin routes */}
              <Route
                path="/admin/tenants"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminTenantsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminUsersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/whitelist"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminWhitelistPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminPaymentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/roles"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminRolesPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ToastProvider>
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}
